<template lang="pug">
  div
    header.header(
      :class="{'header_scrolled': isScrolled}"
    )
      .header__wrap
        .header__container.header__container_md
          .header__col.d-lg-none
            HeaderMenu(
              class="header__col-item"
              :isMobile="true"
              :newYearFeatureEnabled="newYearFeatureEnabled"
              :newYearLogoUrl="newYearLogoUrl"
              :newAppUrl="newAppUrl"
            )
          .header__col.header__col_center-mobile
            .header__col-item
              a.header__logo(:href="$getEnvVar('VUE_APP_RR_URL')")
                .logo
                  img.logo__symbol(v-if="newYearFeatureEnabled" :src="newYearLogoUrl" alt="")
                  img.logo__symbol(v-else src="@/assets/img/logo.svg" alt="")
            HeaderMenu(
              class="header__col-item header__nav d-none d-lg-block"
              :newAppUrl="newAppUrl"
            )
          .header__col.header__col_right
            template(v-if="!isAuthorized")
              .header__col-item
                a.d-xl-none(
                  class="button button_secondary button_circle"
                  :href="$getEnvVar('VUE_APP_RR_URL') + 'user/login'"
                )
                  span.button__icon
                    icon(icon-name="user")
                a.d-none.d-xl-block(
                  class="button button_secondary"
                  :href="$getEnvVar('VUE_APP_RR_URL') + 'user/login'"
                )
                  span.button__icon
                    icon(icon-name="user")
                  span.button__text Личный кабинет
            template(v-else)
              .header__col-item.header__profile
                button.avatar(ref="avatar" type="button")
                  Avatar(
                    :username="user.fullName"
                    :img="user.avatarSmallUrl"
                  )
                Dropdown(
                  trigger="avatar"
                  listeners="hover click"
                  placement="bottom-end"
                )
                  template(slot="items")
                    .dropdown__item(v-for="profileItem in profileNav")
                      a.dropdown__link(:href="profileItem.link")
                        icon.dropdown__icon(:icon-name='profileItem.icon')
                        span.dropdown__text {{ profileItem.name }}
                    .divider
                    .dropdown__item
                      a.dropdown__link(href="#" @click.prevent="logout")
                        icon.dropdown__icon(icon-name='logout')
                        span.dropdown__text Выйти
    .header-offset
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import HeaderMenu from './HeaderMenu.vue'

export default {
  name: 'Header',
  components: {
    Avatar,
    HeaderMenu
  },
  props: {
    newYearFeatureEnabled: {
      type: Boolean,
      default: false
    },
    newYearLogoUrl: {
      type: String,
      required: ''
    }
  },
  data () {
    return {
      profileNav: [
        { name: 'Профиль', icon: 'user', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile' },
        { name: 'Документы', icon: 'solution', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/documents' },
        { name: 'Регистрации', icon: 'badge', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/registrations' },
        { name: 'Заказы', icon: 'shopping-bag', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/orders' },
        { name: 'Оценки', icon: 'five-of-five', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/my-marks' },
        { name: 'Мои чемпионаты', icon: 'trophy', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/my-championships' },
        { name: 'Команды', icon: 'team', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/my-teams' },
        { name: 'Мои клубы', icon: 'user-groups', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/my-clubs' },
        { name: 'Тренировки', icon: 'time-limit', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile/my-trainings' }
      ],
      isScrolled: false
    }
  },
  computed: {
    ...mapState('user', ['user', 'isAuthorized']),
    ...mapGetters('features', ['newAppUrl'])
  },
  methods: {
    ...mapActions('user', ['logout']),
    toggleHeader () {
      this.isScrolled = window.pageYOffset > 10
    }
  },
  mounted () {
    document.removeEventListener('scroll', this.toggleHeader)
    document.addEventListener('scroll', this.toggleHeader)
  }
}
</script>

<style lang="scss" scoped>
  // Header
  .header {
    background-color: $color-white;
    box-shadow: $elevation-deth-8;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;

    &__wrap {
      background-color: inherit;
      padding-left: 8px;
      padding-right: 8px;

      @media (min-width: breakpoint(md)) {
        padding-left: 12px;
        padding-right: 12px;
      }
    }

    &__container, &__logo {
      height: 56px;

      @media (min-width: breakpoint(md)) {
        height: 64px;
      }
    }

    &__container {
      display: flex;
      align-items: center;
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      &_md {
        max-width: 1224px;
      }
    }

    &__col {
      display: flex;
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
      margin: 0 -10px;
      align-items: center;

      &_right {
        justify-content: flex-end;

        @media (min-width: breakpoint(lg)) {
          flex: 0 1 auto;
        }
      }

      &_center {
        justify-content: center;
        flex-basis: auto;
      }

      &_center-mobile {

        @media (max-width: breakpoint(lg, max)) {
          justify-content: center;
          flex-basis: auto;
        }
      }
    }

    &__col-item {
      flex: 0 0 auto;
      margin-left: 10px;
      margin-right: 10px;
      min-width: 0;
    }

    &__col-divider {
      flex: 0 0 auto;
      width: 1px;
      height: 20px;
      background-color: map_get($color-neutral-black, 15);
      margin: 0 8px;

      @media (min-width: breakpoint(md)) {
        margin: 0 10px;
      }
    }

    &__logo {
      display: block;
      position: relative;
      width: 80px;

      &::before {
        content: "";
        position: absolute;
        display: block;
        background: $color-white;
        box-shadow: $elevation-deth-4;
        width: 100%;
        padding-top: 100%;
        border-radius: 50%;
        z-index: -1;
      }

      @media (min-width: breakpoint(md)) {
        width: 104px;
      }

      @media (min-width: breakpoint(lg)) {
        margin-right: 8px;
        margin-left: -4px;
      }

      @media (min-width: breakpoint(xl)) {
        margin-right: 32px;
      }
    }

    &__nav {
      flex-grow: 1;
      flex-shrink: 1;
    }

    &__menu-btn {

      .header__menu-close {
        display: none;
      }

      &.has-dropdown {
        background-color: $color-white;

        .header__menu-burger {
          display: none;
        }

        .header__menu-close {
          display: block;
        }
      }
    }

    &__hashtag {
      display: none;

      @media (min-width: breakpoint(md)) {
        display: flex;
      }
    }

    &__profile {
      position: relative;
    }
  }

  .header-offset {
    flex: 0 0 auto;
    height: 56px;

    @media (min-width: breakpoint(md)) {
      height: 64px;
    }
  }

  .logo {
    width: 100%;
    padding-top: 100%;
    position: relative;
    border-radius: 50%;

    &__symbol {
      display: block;
      position: absolute;
      width: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }

  .logo, .header__logo::before {
    transform-origin: top center;
    transition: $transition-default;
    transition-property: box-shadow, transform;

    .header_scrolled & {
      transform: scale(0.7);

      @media (min-width: breakpoint(md)) {
        transform: scale(0.61);
      }
    }
  }

  .avatar {
    display: inline-block;
    background: none;
    border: none;
    padding: 0;
    vertical-align: middle;
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    user-select: none;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: -5px;
      left: -5px;
      right: -5px;
      bottom: -5px;
      border: 3px solid rgba($color-primary, 0.65);
      pointer-events: none;
      opacity: 0;
      transition: $transition-default;
      border-radius: inherit;
      z-index: 1;
    }

    &:focus::after {
      opacity: 1;
    }
  }

  .header-nav {
    display: flex;
    align-items: center;
    justify-content: center;

    &__item {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

    &__link {
      display: block;
      color: inherit;
      font-weight: $font-weight-semibold;
      text-decoration: none;
      position: relative;
      padding: 4px 0;

      &::before {
        content: "";
        display: block;
        width: 0;
        height: 2px;
        background-image: $gradient-horizontal-primary;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }

      &.active::before,
      .no-touch &:hover::before {
        width: 100%;
        transition: $transition-default;
      }
    }
  }

  .flag-img {
    display: block;
    width: 22px;
    border: 1px solid #e8e6e8
  }

  @keyframes showHeader {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

</style>
